import React, {FC, useEffect, useRef, useState} from "react";
import NcModal from "components/NcModal/NcModal";
import Textarea from "components/Textarea/Textarea";
import ButtonPrimary from "components/Button/ButtonPrimary";

import {doc, updateDoc} from "firebase/firestore";
import {auth, db, storage} from "../../configs/firebase-config";
import {displayToast, toastType} from "../../global/Functions";
import {DEMO_CATEGORIES} from "../../data/taxonomies";
import {getDownloadURL, ref, uploadBytesResumable} from "firebase/storage";
import {useDropzone} from "react-dropzone";
import Label from "../Label/Label";
import Input from "../Input/Input";
import Select from "../Select/Select";

export interface ModalEditPostProps {
    show: boolean;
    onCloseModalEditPost: () => void;
    data?: any
}

const ModalEditPost: FC<ModalEditPostProps> = ({show, onCloseModalEditPost, data}) => {

  let updateObject: object | undefined = undefined;
  const [defaultTitle, setDefaultTitle] = useState<string>();
  const [defaultAppendix, setDefaultAppendix] = useState<string>();
  const [defaultCategories, setDefaultCategories] = useState<any>([]);
  const [defaultTags, setDefaultTags] = useState<any[]>([]);
  const [defaultContent, setDefaultContent] = useState<string>();


  const [title, setTitle] = useState<string>("");
  const [appendix, setAppendix] = useState<string>("");
  const [categories, setCategories] = useState<any>();
  const [tags, setTags] = useState<any[]>();
  const [content, setContent] = useState<string>("");
  const [preview, setPreview] = useState<string>();

  const [image, setImage] = useState<File>();

  useEffect(() => {
    setDefaultTitle(data.title);
    setDefaultAppendix(data.appendix);
    setDefaultCategories(data.categories);
    setDefaultTags(data.tags);
    setDefaultContent(data.content);
    setPreview(data.image?.downloadURL)
  }, [data])

  // useEffect(() => {
  //   console.log(title);
  //   console.log(appendix);
  //   console.log(categories);
  //   console.log(tags);
  //   console.log(content);
  // }, [title, appendix, categories, tags, content])

  const resetStates = () => {
    setDefaultTitle(data.title);
    setDefaultAppendix(data.appendix);
    setDefaultCategories(data.categories);
    setDefaultTags(data.tags);
    setDefaultContent(data.content);
    setPreview(data.image?.downloadURL)
    setImage(undefined);

    setTitle("");
    setAppendix("");
    setCategories(undefined);
    setTags(undefined);
    setImage(undefined);
    setContent("");
  };

  const uploadPicture = async () => {
    if (!image) return;
    const storageRef = ref(storage, `posts/${auth.currentUser?.uid}/${image.name}`);
    const uploadTask = uploadBytesResumable(storageRef, image);

    await uploadTask.on("state_changed", (snapshot) => {
      // TODO: FRONT-END to design a progress bar, Use the variable progress
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log("Upload is " + progress + "% done");
      switch (snapshot.state) {
        case "paused":
          displayToast("Upload has paused", toastType.warn);
          break;
        case "running":
          displayToast("Upload is running", toastType.info);
          break;
      }
    }, (error) => {
      switch (error.code) {
        case "storage/unauthorized":
          displayToast("Storage authorised", toastType.error);
          break;
        case "storage/canceled":
          displayToast("Storage cancelled", toastType.error);
          break;
        case "storage/unknown":
          displayToast("Storage unknown", toastType.error);
          break;
        default:
          displayToast(error.message, toastType.error);
      }
    }, () => {
      getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
        await updatePost(downloadURL)
      })
    })
  }

  const updatePost = async (downloadURL: string) => {
    const postsDocRef = doc(db, "posts", `${auth.currentUser?.uid}/posts/${data.id}`);
    if (title !== "" && title !== defaultTitle){
      updateObject = {title, ...updateObject}
    }
    if (appendix !== "" && appendix !== defaultAppendix){
      updateObject = {appendix, ...updateObject}
    }
    if (content !== "" && content !== defaultContent){
      updateObject = {content, ...updateObject}
    }
    if (categories && categories !== defaultCategories){
      updateObject = {categories, ...updateObject}
    }
    if (tags && tags !== defaultTags){
      updateObject = {tags, ...updateObject}
    }
    if (downloadURL){
      updateObject = {
        image:
          {
            name: image?.name,
            downloadURL
          },
        ...updateObject
      }
    }
    if (updateObject !== undefined){
      try{
        console.log(updateObject);
        await updateDoc(postsDocRef, updateObject)
        displayToast("Post successfully updated!", toastType.success);
      } catch (e) {
        displayToast(e.code, toastType.error);
      }
    } else {
      displayToast("No Changes", toastType.info);
    }
  }

  const handleSubmitPost = async (e: any) => {
    e.preventDefault();
    if (preview !== data.image.downloadURL){
      await uploadPicture();
    } else {
      await updatePost("");
    }
    onCloseModalEditPost();
    e.target.reset();
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/png,image/jpeg,image/gif",
    maxFiles: 1,
    validator: (image: File) => {
      if (image.size > 2097152) {
        return {
          code: "filesize-too-large",
          message: "File is larger than 2MB",
        };
      }
      return null;
    },
    onDrop: (acceptedFiles) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(acceptedFiles[0]);
      setImage(acceptedFiles[0]);
    }
  });

  const handleKeyDown = (e: any) => {
    if (e.key !== " ") return;
    const value = e.target.value;
    if (!value.trim()) return;
    const tagObj = {
      "id": value,
      "name": value,
      "href": "/",
      "thumbnail": "",
      "count": 0,
      "color": "blue"
    }
    tags
      ? setTags([...tags, tagObj])
      : setTags([...defaultTags, tagObj])
    e.target.value = "";
  };

  const removeTag = (index: number) => {
    tags
      ? setTags(tags?.filter((element, i) => i !== index))
      : setTags(defaultTags?.filter((element, i) => i !== index));
  };

  // useEffect(() => {
  //   if (show) {
  //     setTimeout(() => {
  //       const element: HTMLTextAreaElement | null = textareaRef.current;
  //       if (element) {
  //           (element as HTMLTextAreaElement).focus();
  //       }
  //     }, 400);
  //   }
  // }, [show]);




  const renderContent = () => {
    return (
      <div className="rounded-xl md:border md:border-neutral-100 dark:border-neutral-800 md:p-6">
        <form
          className="grid md:grid-cols-2 gap-6"
          onSubmit={handleSubmitPost}
        >
          <label className="block md:col-span-2">
            <Label>Post Title *</Label>

            <Input
              type="text"
              className="mt-1"
              placeholder="Post Title"
              required
              defaultValue={defaultTitle}
              onChange={(e) => setTitle(e.target.value)}
            />
          </label>
          <label className="block md:col-span-2">
            <Label>Post Appendix</Label>

            <Textarea
              className="mt-1"
              rows={4}
              defaultValue={defaultAppendix}
              onChange={(e) => setAppendix(e.target.value)}
              placeholder={`${auth.currentUser?.displayName}, what is your post about?`}
            />
          </label>
          <label className="block">
            <Label>Category</Label>

            <Select
              className="mt-1"
              placeholder="Select Category"
              required
              defaultValue={defaultCategories[0]?.id}
              onChange={(e) => setCategories([DEMO_CATEGORIES.filter((taxonomy) => taxonomy.id === parseInt(e.target.value))[0]])}
            >
              <option selected disabled>
                Select Category
              </option>
              <optgroup label="Popular Categories">
                <option value="1">NFT</option>
                <option value="2">Crypto Currency</option>
                <option value="3">CryptoVerse</option>
              </optgroup>
                <optgroup label="All Categories">
                  <option value="4">Software Engineering</option>
                  <option value="5">Students</option>
                  <option value="6">FinTech</option>
                  <option value="7">Jobs</option>
                  <option value="8">Learn</option>
                  <option value="9">Setups</option>
                  <option value="10">Financial Advice</option>
                  <option value="11">Upcoming</option>
                  <option value="12">Memes</option>
                  <option value="13">Other</option>
                </optgroup>
            </Select>
          </label>
          <label className="block">
            <Label>Tags</Label>
              <div className="">
                {tags ?
                  <>
                    {tags?.map((tag, index) => (
                      <div className="tag-item my-2 mx-2 cursor-pointer disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50" key={index} onClick={() => removeTag(index)}>
                        <span className="text  ">{tag.name}</span>
                      </div>
                    ))}
                  </> :
                  <>
                    {defaultTags?.map((tag, index) => (
                      <div className="tag-item my-2 mx-2 cursor-pointer disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50" key={index} onClick={() => removeTag(index)}>
                        <span className="text  ">{tag.name}</span>
                      </div>
                    ))}
                  </>
                }

                <Input
                  type="text"
                  className="mt-1"
                  placeholder="Enter a tag, then press space"
                  onKeyDown={handleKeyDown}
                />
              </div>
          </label>

          <div {...getRootProps({ className: "dropzone block md:col-span-2" })}>
            <Label>Featured Image</Label>
            <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-700 border-dashed rounded-md">
              {preview ? (
                <img src={preview} />
              ) : (
                <div className="space-y-1 text-center">
                  <svg
                    className="mx-auto h-12 w-12 text-neutral-400"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 48 48"
                    aria-hidden="true"
                  >
                    <path
                        d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                  </svg>
                  <div className="flex flex-col sm:flex-row text-sm text-neutral-6000">
                    <label
                      htmlFor="file-upload"
                      className="relative cursor-pointer rounded-md font-medium text-primary-6000 hover:text-primary-800 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                    >
                      <span>Upload a file</span>
                      <input className="sr-only" {...getInputProps()} />
                    </label>
                    <p className="pl-1">or drag and drop</p>
                  </div>
                  <p className="text-xs text-neutral-500">
                      PNG, JPG, GIF up to 2MB
                  </p>
                </div>
              )}
            </div>
          </div>
          <label className="block md:col-span-2">
                <Label> Post Content</Label>
                <Textarea
                    className="mt-1"
                    placeholder={`${
                        auth.currentUser?.displayName
                            ? `${auth.currentUser?.displayName}`
                            : "The Demo Author"
                    }, what's on your mind?`}
                    rows={16}
                    required
                    defaultValue={defaultContent}
                    onChange={(e) => setContent(e.target.value)}
                />
            </label>

          <ButtonPrimary className="md:col-span-2" type="submit">
                Publish Article
            </ButtonPrimary>
        </form>
      </div>
    );
  };

  const renderTrigger = () => {
    return null;
  };

  return (
    <NcModal
      isOpenProp={show}
      onCloseModal={onCloseModalEditPost}
      contentExtraClass="max-w-screen-md"
      renderContent={renderContent}
      renderTrigger={renderTrigger}
      modalTitle="Edit Post"
    />
  );
};

export default ModalEditPost;
